import {Directive, ElementRef, HostListener} from '@angular/core';
import {TrackingService} from "../trackingservice/tracking.service";

@Directive({
  selector: '[nxHeaderLink], nx-footer-link a'
})
export class ClicktrackingDirective {
  @HostListener("click", ["$event"])
  click(event: Event) {
    console.log("User Clicked on Window...", (this.el.nativeElement.hash !== ''));
    if (this.el.nativeElement.classList.contains('nx-header__link')) {
      this.trackingService.trackLinkClick((this.el.nativeElement.hash !== ''), 'header', this.el.nativeElement.href, this.el.nativeElement.innerText)
    }else if (this.el.nativeElement.parentElement.classList.contains('nx-footer__link')){
      this.trackingService.trackLinkClick((this.el.nativeElement.hash!==''), 'footer', this.el.nativeElement.href,this.el.nativeElement.innerText)

    }
    console.log("User Clicked on Window...", this.el.nativeElement.href);
    console.log("User Clicked on Window...", window.location.href);
    console.log("User Clicked on Window...", window.location);
    console.log("User Clicked on Window...", this.el);
    // console.log("User Clicked on Window...",event.target);
  }


  constructor(private el: ElementRef, private trackingService: TrackingService) {
  }



}
